import React from 'react';
import { FormattedPlural } from 'react-intl';
import cx from 'classnames';
import moment from 'moment';
import { injectIntl } from 'react-intl';

const getDateString = (date, t) => {
  const today = moment();
  const tomorrow = moment().add(1, 'day');
  const day = moment(date);

  if (today.isSame(day, 'day')) {
    return t.today;
  }

  if (tomorrow.isSame(day, 'day')) {
    return t.tomorrow;
  }

  return day.format(t.other_day);
};

const JobReviewListHeader = ({ className, loading, date, total, intl }) => {
  const t = intl.messages.modules.job_review.list_header;
  return (
    <div
      className={cx(className, {
        [`${className}__loading`]: loading,
      })}
    >
      {!!date && (
        <>
          <span className="day">{getDateString(date, t)}</span>({total}&nbsp;
          <FormattedPlural value={total} one={t.driver} other={t.drivers} />)
        </>
      )}
    </div>
  );
};

export default injectIntl(JobReviewListHeader);
